<app-leveltwo [pageId]="2">
  <div class="General">

      <h3>{{'Religious.PageTitle'|translate}}</h3>

      <p>{{'Religious.Theseexemptions'|translate}}<b> {{'Religious.213'|translate}}</b> {{'Religious.oremailed'|translate}} <a href="mailto:exempt@assessor.lacounty.gov">{{'Religious.exempt'|translate}}</a></p>

      <p><a href="https://leginfo.legislature.ca.gov/faces/codes_displayText.xhtml?lawCode=CONS&division=&title=&part=&chapter=&article=XIII" target="_blank">{{'Religious.Sections4'|translate}}</a> {{'Religious.and'|translate}} <a href="https://leginfo.legislature.ca.gov/faces/codes_displaySection.xhtml?sectionNum=207.&lawCode=RTC" target="_blank">{{'Religious.section207'|translate}}</a> {{'Religious.allow'|translate}}</p>
      <p>{{'Religious.Ifanother'|translate}}</p>
      <p>{{'Religious.Thereligious'|translate}}</p>



  </div>
</app-leveltwo>
